import axios from "axios";
import store from "@/store";
import {getPupil} from "@/utils/parseObj";
const {v4: uuidv4} = require("uuid");

export const putTest =  (test) => {
    return   axios
         .put(
             `/test/update`, test
         )
}

export const postNewTestName =  (name, subject, date, grade) => {
const obj = {
    id: uuidv4(),
    name: name,
    subject: subject,
    date: date,
    grade: grade,
    user: store.state?.user.id,
}
    const {data: addNameRes} =  axios.post(`/test/add-name`, obj)
}

export const getTestNamesOfUser = async (a) => {

    const {data} = await axios
        .get(
                `/test/all-names/${a.userId}/${a.startDate}/${a.endDate}`
        )
    console.log("data00", data)
    const hashMapNames = {}
    data?.forEach(name => {
        if(!hashMapNames[name.grade]) hashMapNames[name.grade] = {}
        if(!hashMapNames[name.grade][name.subject]) hashMapNames[name.grade][name.subject] = true
    })

    return hashMapNames
}

export const getData = async (a) => {
    // await postNewTestName("1")

    const {data} = await axios
        .get(
            `/test/all/${a.grade}/${a.subject}/${a.startDate}/${a.endDate}`
        )
    const hashMapScores = {}

    const pupils = store.state?.pupils.filter(p =>  p.grade?.id === a.grade)
    pupils?.forEach(p => hashMapScores[p.id] = { pupil: p.id })
    data.testList?.forEach((test) => {
        // testNames.add(test.name)
        // if (hashMapScores[test.pupil] === undefined){
        //     hashMapScores[test.pupil] = {
        //         pupil: test.pupil
        //     }
        // }

        hashMapScores[test.pupil] = {...hashMapScores[test.pupil], ...{[test.nameId?.id || test.name] : test }}
    })
    pupils?.forEach(p => {
        data.testNames?.forEach(name => hashMapScores[p.id][name.id] = hashMapScores[p.id][name.id]?.score ??  null)

    })
    const array = []
Object.keys(hashMapScores).forEach((key) => {
    array.push(hashMapScores[key])
})
    hashMapScores["00000"] = {'pupil':'00000'}
    data.testNames?.forEach(name =>{
        const tests = data.testList.filter(t => t.nameId?.id === name.id  && t.score >= 0 )
        const sum = tests.reduce((accumulator, object) => { return accumulator + object.score}, 0)
        const avg  = sum / tests.length

        if (sum > 0 ){
            hashMapScores["00000"] = {...hashMapScores["00000"]  ,[name.id] :avg.toFixed(0) || undefined}

        }

    })
    array.unshift(hashMapScores["00000"])
    array.sort((a, b) => {
        const pupilALastname = getPupil(a.pupil)?.lastname
        const pupilBLastname = getPupil(b.pupil)?.lastname
        if (pupilALastname < pupilBLastname) {
            return -1;
        }
        if (pupilBLastname > pupilALastname) {
            return 1;
        }
        return 0;
    })
    console.log("array", array)

    return {testsPure: data, testList: array ,testNames : data.testNames}

}

